import {
  Backdrop,
  Box,
  Button,
  TextField,
  Grid,
  Typography,
  Link,
} from "@material-ui/core";
import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import UseTranslation from "../../services/UseTranslation";
import { action_types } from "../../types/ActionTypes";
import {
    ApplicationState,
 } from "../../types/Master";
import "../../custom.css";
import { Container } from "reactstrap";
import {
  CustomerSignUp,
  CreateEmailForRegistration
} from "../../services/CustomerService";
import validator from "validator";
import SolmetexLogoSvg from "../../images/Solmetex_logo.svg";

const translation = UseTranslation();

const mapStateToProps = (state: ApplicationState) => ({
  isLoading: state.isLoading,
  user: state.user,
  isAuthUser: state.isAuthUser,
});

const mapDispatchToProps = (dispatch: Dispatch<action_types>) => {
  return {
    setLoader: (val: boolean) => dispatch({ type: "SET_LOADER", payload: val }),
    setToastMessage: (Message: string, Status: boolean) =>
      dispatch({ type: "SET_TOAST_MESSAGE", payload: { Message, Status } }),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const EmailVerification = (props: PropsFromRedux) => {
  const { isLoading, setLoader, setToastMessage } = props;
  const [validationMessage, setValidationMessage] = React.useState<{
    email: string;
    password: string;
  }>({ email: "", password: "" });

  const [isLoadView, setIsLoadView] =
    React.useState<boolean>(true);
  const [emailToVerify, setEmailToVerify] = React.useState<string>("");

  const handleSendEmail = (e: any) => {
    e.preventDefault();
    if (validate()) {
      setLoader(true);
      CreateEmailForRegistration(emailToVerify)
        .then((res) => {
          setLoader(false);
          setIsLoadView(false);
                 })
        .catch((ex) => {
          console.error(ex);
          setLoader(false);
        });
    }
    else {

    }
  };


  const validate = (): boolean => {
    let isValid = true;
    if (!validator.isEmail(emailToVerify)) {
      isValid = false;
      setValidationMessage({
        ...validationMessage,
        email: `* ${translation.emailValidation}`,
      });
    }

    return isValid;
  };

  const handleBack = (): void => {
    debugger;
    setIsLoadView(true);
    setEmailToVerify("");
  };

  

  return (
    <Box className="sx-signUpBg">
      <Container>
        <Backdrop
          style={{
            zIndex: 2250,
          }}
          open={isLoading}
        >
          <div className="loading-icon" />
        </Backdrop>
        <Box className="sx-login">
          <Grid container>
            <Grid item xs={12} md={6} className="m-auto text-center">

              {isLoadView && (
                <Box
                  component="form"
                  onSubmit={handleSendEmail}
                  className="sx-loginBg"
                >
                  <div className="text-center mb-5">
                    <img
                      src={SolmetexLogoSvg}
                      alt="Solmetex"
                      className="sx-loginLogo"
                    />
                  </div>
                  <Typography variant="h1" className="sx-loginTitle">
                    Confirm Your Email Address
                  </Typography>
                  <Typography className="mb-4 sx-grey">
                   Enter the email address you'll use to log into the customer portal. After clicking "Submit," you'll receive a verification email within a few minutes. Click the link in that email to activate your account. If you don't receive it, check your spam folder or contact Solmetex Customer Service at 800.216.5505 or via chat.
                  </Typography>
                  <TextField
                    className="sx-inputGroup"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    name="email"
                    label="email"
                    onChange={(e) => {
                      setEmailToVerify(e.target.value);
                    }}
                    value={emailToVerify}
                    InputProps={{
                      disableUnderline: true,
                      className: "sx-input",
                    }}
                    InputLabelProps={{ className: "sx-input-label" }}
                    variant="filled"
                  />

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={isLoading}
                    className="sx-button mt-4"
                  >
                    {translation.submit}
                  </Button>

                  <Typography
                    variant="h5"
                    className="sx-loginSubTitle mt-4 pt-3"
                  >
                    {translation.alreadyHaveAnAccount}
                    <Link href="/signin" className="sx-blue sx-bold ml-2">
                      {translation.signin}
                    </Link>
                  </Typography>
                </Box>
              )}
              {!isLoadView && (
                <Box

                  className="sx-loginBg"
                >
                  <div className="text-center mb-5">
                    <Link href="/">
                      <img
                        src={SolmetexLogoSvg}
                        alt="Solmetex"
                        className="sx-loginLogo"
                      />
                    </Link>
                  </div>
                  <Typography variant="h1" className="sx-loginTitle mb-1">
                  Please Verify Your Email Address
                  </Typography>
                  <Typography className="mb-4 sx-grey">
                    We've sent a verification email to the address below. If this is incorrect, click "Back" to re-enter your email address.
                                  </Typography>
                                  <Typography className="mb-4 sx-grey">
                                      If you don't see the email in your inbox, please check your Spam/Junk folder.
                                  </Typography>
                  <Typography className="mb-4 tw-font-bold">
                    {emailToVerify}
                  </Typography>
                  <Typography className="mb-4 sx-grey">
                    If you don't receive an email to verify your email address , please contact Solmetex customer services on 1-800-216-5505.

                  </Typography>

                  <Button

                    fullWidth
                    variant="contained"
                    disabled={isLoading}
                    className="sx-button mt-4"
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                  <Typography
                    variant="h5"
                    className="sx-loginSubTitle mt-4 pt-3"
                  >
                    {translation.alreadyHaveAnAccount}
                    <Link href="/signin" className="sx-blue sx-bold ml-2">
                      {translation.signin}
                    </Link>
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default connector(EmailVerification);
